import React from "react";
import "../layout.css";
import { CiCircleAlert } from "react-icons/ci";

const LogoutModal = ({ show, onClose, onConfirm }) => {
  if (!show) return null;

  return (
    <div className="user-delete-modal-overlay" onClick={onClose}>
      <div
        className="user-delete-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="alert-content text-center">
          <CiCircleAlert className="user-delete-alert-icon" />
          <h2>Are you sure?</h2>
          <p>Do you really want to log out? You’ll be redirected to the login page.</p>
        </div>

        <div className="d-flex justify-content-around align-items-center gap-3 mt-4">
          <button className="user-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="user-delete-btn" onClick={onConfirm}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
